import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

import { ProductDao } from '@app/dao/product/product.dao';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'crowdfunding-amount',
    templateUrl: './crowdfunding-amount.component.html',
    styleUrls: ['./crowdfunding-amount.component.scss'],
    standalone: false
})
export class CrowdfundingAmountComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  maxSubscriptionAmount: number = Infinity;
  minSubscriptionAmount: number = 0;
  loading: boolean = false;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    private productDao: ProductDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.loading = true;
    const pledge = this.subscriptionFacade.getPledge();
    const pledgeProduct = pledge?.products?.[0];
    this.productDao
      .getProduct(pledgeProduct.productId.toString())
      .subscribe(() => {
        this.loading = false;
        this.subscriptionFacade.initForm(this);
      });
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
